import React from "react";
import BookingForm from "./BookingForm";
import { sanh } from "../assets/images";

const Hero = () => {
  return (
    <section className="relative pt-[10px]">
      <div
        className="relative h-[400px] bg-cover bg-center flex justify-center items-center w-full"
        style={{
          backgroundImage: `url(${sanh})`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        <div className="relative z-10 sm:w-[100%] ssx:px-[20px] ssx:w-[100%] lg:w-[90%] mx-auto">
          <BookingForm />
        </div>
      </div>
    </section>
  );
};

export default Hero;
